// extracted by mini-css-extract-plugin
export default {"container":"NoProductFound_container__Hl74S"};